import styled from 'styled-components'

export const Container = styled.div`
    max-width: 1280px;
    margin: 0 auto;
    padding-top: 20px;
`

export const Title = styled.div`
    font-size: 30px;
    font-weight: 700;
`

export const Description = styled.div`
    margin: 10px 0 30px 5px;
    font-size: 14px;
`

type propsType = {
    isShow: boolean
}

export const FurtherDesc = styled.div<propsType>`

    div {
        cursor: pointer;
        padding-bottom: 20px;
        
        &:hover {
            font-weight: 700;
        }

        img {
            position: relative;
            top: 3px;
            width: 13px;
            transform: ${(props) => props.isShow ? "rotate(180deg)": "rotate(90deg)"}
        }
    }

    ol {
        margin-top: -10px;
        padding-left: 30px;
        // border: 1px solid #aaa;
    }

    li {
        line-height: 20px;
    }
`